import React, { useMemo } from 'react';
import { POS } from './layout';
import { fonts, placeTL, formatDate } from './ui';

// 判斷是否已到期
const isExpired = (expiryDate) => {
  if (!expiryDate) return false;
  const exp = expiryDate.split?.('T')?.[0];
  if (!exp) return false;
  const today = new Date();
  const expiry = new Date(exp);
  today.setHours(0, 0, 0, 0);
  expiry.setHours(0, 0, 0, 0);
  return expiry < today;
};

export default function CardHeader({ px, profile }) {
  const zTop = { zIndex: 2 };
  const expired = useMemo(() => isExpired(profile?.MEMBER_EXPIRY), [profile?.MEMBER_EXPIRY]);
  const hasLockerExpired = Boolean(profile?.lockerNumber && profile?.lockerExpired);
  
  return (
    <>
      {/* 主要欄位：值（左上錨點） */}
      <div style={{
        ...placeTL(px, POS.name.x, POS.name.y+20, fonts.big),
        ...zTop,
        fontSize: fonts.big.fontSize - 6,
        maxWidth: px(400),
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}>
        {profile?.NAME || '-'}
      </div>
      <div style={{ 
        ...placeTL(px, POS.level.x + 60, POS.level.y+20, fonts.big), 
        ...zTop,
        fontSize: fonts.big.fontSize - 6,
        ...(expired ? { textDecoration: 'line-through', opacity: 0.7 } : {})
      }}>
        {profile?.LEVEL || '-'}
      </div>
      <div style={{ 
        ...placeTL(px, POS.expiry.x, POS.expiry.y+20, fonts.date), 
        ...zTop,
        ...(expired ? { color: '#b00020', fontWeight: 900 } : {})
      }}>
        {expired ? '已到期' : formatDate(profile?.MEMBER_EXPIRY)}
      </div>
      {/* 個人櫃到期提醒（會員卡頁面） */}
      {hasLockerExpired && (
        <div style={{
          ...placeTL(px, POS.expiry.x, POS.expiry.y + 52, fonts.date),
          ...zTop,
          color: '#b00020',
          fontWeight: 700,
          fontSize: 14,
        }}>
          個人櫃已到期
        </div>
      )}
    </>
  );
}
